import Section from 'components/base/Section';
import { Title } from 'components/base/Title';
import { useUser } from 'context/user-context';
import { useNavigate } from 'react-router-dom';
import { LivraisonBanniere } from 'components/LivraisonBanniere';
import { Slider } from 'components/base/Slider';
import { Button } from 'components/base/Button';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import FAQ from './FAQ';

function Home() {
  const navigate = useNavigate();
  const images = ["/hero-img/img1.JPG", "/hero-img/img2.jpg", "/hero-img/img3.jpg", "/hero-img/img4.jpg", "/hero-img/img5.jpg", "/hero-img/img6.png"];


  const { user, isAuthenticated, isLoading } = useUser();



  if (isLoading) {
    return <div>Chargement...</div>;
  }

  if (!isAuthenticated || !user) {
    return <div>Veuillez vous connecter pour accéder à votre espace personnel.</div>;
  }

  return (
    <>
      <Section fullwidth className='-mt-4 relative'>
        <div className='absolute top-0 left-0 w-full h-full bg-secondary-700 opacity-50 z-20' />
        <Slider
          images={images}
          animation='infinite'
          duration={5000}
          height='75vh'
        />
        <div className='absolute top-0 left-0 w-full h-full flex flex-col items-center justify-between z-20'>
          <div className='max-w-screen-lg mx-auto my-4 w-full'>
            <LivraisonBanniere />
          </div>
          <div className='flex flex-col items-center justify-center my-8 gap-8'>
            <div className='text-center text-white text-shadow-black font-bold px-2'>
              <Title type='h2' className='mb-1'>Carole et Sylvain LEBAS</Title>
              <Title type='h3'>Apiculteur Producteur et Recoltant à Torcy-Le-Grand</Title>
            </div>
            <Button
              variant='primary'
              iconRight={<ArrowRightIcon className='w-4 h-4' />}
              onClick={() => navigate('/produits')}
            >Voir nos produits</Button>
          </div>
        </div>

      </Section>


      <Section className='my-8'>
        <div className='space-y-6'>
          <Title type='subdisplay' centered className='mb-4'>Présentation</Title>
          <div className='space-y-2'>
            <Title type='h3'>Nos produits</Title>
            <p>
              Nous proposons deux miels artisanaux, récoltés avec soin au rythme des saisons.
              Chaque pot reflète le travail des abeilles et les floraisons naturelles de la région.
            </p>
          </div>
          <div className='space-y-2'>
            <Title type='h3'>Miel de Printemps</Title>
            <p>
              Récolté entre fin mai et début juin. Ce miel se distingue par sa texture crémeuse et sa couleur très claire.
              Il doit sa douceur à la grande diversité de fleurs printanières qui s'épanouissent dès la sortie de l'hiver et durant tout le printemps.
              Notamment sur les arbres, les pruniers, les aubépines, les cerisiers et dans  les champs le colza, les pissenlits.<br />
              C’est un miel délicat, léger et particulièrement apprécié des amateurs de textures fondantes.
            </p>
          </div>
          <div className='space-y-2'>
            <Title type='h3'>Miel d'Été</Title>
            <p>
              Récolté fin juillet, ce miel d’été est un miel polyfloral à la belle teinte dorée. <br />
              D'un goût plus prononcé et plus parfumé que le miel de printemps, il doit ses caractéristiques au nectar des fleurs du début d'été.
              Principalement des arbustes et des fleurs vivaces et annuelles des jardins, des tilleuls, des ronces et des framboisiers.
              Il dévoile des notes florales marquées et reste liquide plusieurs semaines après la récolte pour se cristalliser naturellement à l'arrivée de l'automne.
              Ce miel de caractère est idéal pour ceux qui aiment les saveurs plus soutenues.
            </p>
          </div>
          <div className='space-y-2'>
            <Title type='h3'>Une production dépendante de la nature</Title>
            <p>
              Notre miel est naturel et ne subit aucune transformation. Dès sa récolte, il est extrait, décanté et mis en pots.<br /><br />
              La quantité de miel produite varie chaque année selon la météo, la floraison et l’ensoleillement. Nous ne réalisons que deux récoltes par an : printemps et été.
              En dehors de ces périodes le miel récolté par les abeilles est laissé à leur disposition pour leur propre consomation.<br />
              Si nos stocks sont épuisés, il faudra patienter jusqu’à la prochaine saison pour retrouver nos miels fraîchement récoltés.
            </p>
          </div>
        </div>
      </Section>

      <div className='py-8'>
        <FAQ />
      </div>
    </>
  );
}

export default Home;